/**
 * Normalize multiple spaces in a string to single spaces and trim whitespace
 * from both ends.
 */

export default function normalizeSpaces(str: string): string {
  return str.replace(/\s+/g, " ").trim();
}
